import React from "react"
import types from "prop-types"
import { TaskAnswerEditorsContextProvider } from "contexts/TaskAnswerEditorsContext"
import { taskShape } from "utils/propTypeShapes"
import TaskPanelAssignees from "./TaskPanelAssignees"
import TaskPanelMembers from "./TaskPanelMembers"
import TaskPanelNotes from "./TaskPanelNotes"
import TaskStatusControl from "./TaskStatusControl"
import TaskResponse from "./TaskResponse"

const TaskPanel = ({ onTaskClosure = undefined, task }) => {
  const { id } = task

  return (
    <TaskAnswerEditorsContextProvider taskId={id}>
      <div className="flex flex-col gap-12 items-center w-full rounded-b-lg bg-white pt-4">
        <div className="flex flex-col gap-4 w-full">
          <TaskPanelAssignees task={task} />
          <TaskPanelMembers task={task} />
          <TaskPanelNotes task={task} />
        </div>
        <TaskResponse
          task={task}
          taskControls={<TaskStatusControl task={task} onTaskClosure={onTaskClosure} />}
        />
      </div>
    </TaskAnswerEditorsContextProvider>
  )
}

TaskPanel.propTypes = {
  onTaskClosure: types.func,
  task: taskShape.isRequired,
}

export default TaskPanel
